import * as actionTypes from '../config/actionTypes';
import axios from '../config/axios';

import {
  getAuthHeaders,
  manageAuthActionError,
} from '../auth/actions';


export const toggleDashboardLoading = () => {
  return {
    type: actionTypes.TOGGLE_DASHBOARD_LOADING,
  };
};


export const displayFeed = (data) => {
  return {
    type: actionTypes.DISPLAY_FEED,
    payload: data,
  };
};


export const dashboardError = (error) => {
  return {
    type: actionTypes.DASHBOARD_ERROR,
    payload: error,
  };
};


export const getUserFeed = (token, url) => {
  return (dispatch) => {
    dispatch(toggleDashboardLoading());
    let activityURL = null;
    if (url) {
      activityURL = url;
    } else {
      activityURL = '/activities/get-user-activities';
    }

    axios.get(activityURL, getAuthHeaders(token))
      .then((response) => {
        dispatch(displayFeed(response.data));
        dispatch(toggleDashboardLoading());
      })
      .catch((error) => {
        dispatch(manageAuthActionError(error, token));
        dispatch(dashboardError('Something went wrong! Please contact tech support'));
        dispatch(toggleDashboardLoading());
      });
  };
};


export const feedUnmount = () => {
  return {
    type: actionTypes.FEED_UNMOUNT,
  };
};



// WEBPACK FOOTER //
// ./src/dashboard/actions.js